import axios from "axios";

const donatorsApiBaseUrl = import.meta.env.VITE_CENTRAL_API;

const donatorsApi = axios.create({
  baseURL: donatorsApiBaseUrl,
});

export interface ResolveDonatorResponse {
  id: string;
}

export interface ResolveDonatorRequest {
  name: string;
  email: string;
}

export const resolveDonator = async (
  payload: ResolveDonatorRequest,
): Promise<ResolveDonatorResponse> => {
  const response = await donatorsApi.post<ResolveDonatorResponse>(
    "/api/donator/resolve",
    payload,
  );
  return response.data;
};
